import ParentGuardianDetailsScreen from '../../screens/ParentGuardianDetailsScreen'

const ParentGuardianDetails = () => {
  return <ParentGuardianDetailsScreen />
}

export default ParentGuardianDetails
